module.exports = __webpack_public_path__ + "fe189a88be9c194eeef014013e27d725.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_2_0.woff2
// module id = 534
// module chunks = 0